<template>
  <div class="sidebar-content">
    <!-- URL if opened in modal -->
    <!-- <div v-if="opener == 'modal'">
                    <p>
                      Share link: {{ 'https://bytbostad.se/bostad/' + flat.id }}
                    </p>
                    <button class="button">Facebook share</button>
                  </div> -->

    <header>
      <h1>{{ flat.street }} {{ flat.street_number }}</h1>
      <h2>{{ [flat.hood, flat.city].filter(Boolean).join(', ') }}</h2>
    </header>

    <!-- Ad data grid -->
    <div class="grid-x">
      <!-- Type of home -->
      <!-- <div class="cell small-12">
        <div class="ad-data">
          <p><span>Boendeform</span>: <span v-if="flat.type==1">Hyresrätt</span><span v-if="flat.type==2">Bostadsrätt</span></p>
        </div>
      </div> -->

      <!-- If it's a BRF -->
      <div v-if="flat.type==2" class="cell small-12">
        <div class="ad-data">
          <p>Marknadsvärde: {{ flat.price | currency }}</p>
        </div>
      </div>

      <!-- Landlord -->
      <div v-if="flat.landlord" class="cell small-12">
        <div class="ad-data">
          <p><span v-if="flat.type==1">Hyresvärd</span><span v-if="flat.type==2">BRF</span>: <span>{{ flat.landlord }}</span></p>
        </div>
      </div>

      <div class="cell small-6">
        <div class="ad-data">
          <span class="nav-icon">
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="17">
              <path
                fill-rule="evenodd"
                d="M6.187485 10.9999738c-.94531 0-1.754553-.3365875-2.427728-1.0097632-.673176-.6731757-1.009764-1.4824184-1.009764-2.4277286 0-.9453103.336588-1.7545529 1.009764-2.4277286.673175-.6731757 1.482418-1.0097632 2.427728-1.0097632.94531 0 1.754553.3365875 2.427729 1.0097632.673176.6731757 1.009763 1.4824183 1.009763 2.4277286 0 .9453102-.336587 1.7545529-1.009763 2.4277286s-1.482419 1.0097632-2.427729 1.0097632zm0-5.4999869c-.572915 0-1.059893.2005206-1.460934.6015611-.40104.4010404-.601561.8880189-.601561 1.460934 0 .5729151.200521 1.0598935.601561 1.460934.401041.4010405.888019.6015611 1.460934.6015611s1.059894-.2005206 1.460934-.6015611c.401041-.4010405.601561-.8880189.601561-1.460934 0-.5729151-.20052-1.0598936-.601561-1.460934-.40104-.4010405-.888019-.6015611-1.460934-.6015611zm16.499961-1.3749967c.859373 0 1.661454.2148432 2.406244.6445297.74479.4296865 1.332028 1.0169249 1.761715 1.7617145.429686.7447897.644529 1.5468713.644529 2.4062443v7.2187328c0 .0859373-.035807.1647129-.107421.2363275-.071615.0716147-.15039.1074217-.236328.1074217h-.687498c-.085937 0-.164713-.035807-.236328-.1074217-.071614-.0716146-.107421-.1503902-.107421-.2363275v-2.4062443H1.374997v2.4062443c0 .0859373-.035807.1647129-.107422.2363275-.071615.0716147-.15039.1074217-.236327.1074217H.343749c-.085937 0-.164713-.035807-.236327-.1074217C.035807 16.3209244 0 16.2421488 0 16.1562115V.3437492C0 .2578119.035807.1790363.107422.1074216.179036.035807.257812 0 .343749 0h.687499c.085937 0 .164712.035807.236327.1074216.071615.0716147.107422.1503903.107422.2363276v12.0312213h9.624977v-7.562482c0-.2005205.064453-.3652335.193359-.4941394.128906-.128906.293619-.1933589.494139-.1933589h10.999974zm3.437492 8.2499803V8.9374787c0-.9453103-.336588-1.7545529-1.009764-2.4277286-.673175-.6731757-1.482418-1.0097632-2.427728-1.0097632H12.37497v6.8749836h13.749968z" />
            </svg> -->
            <svg width="29px" height="22px" viewBox="0 0 29 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="room" transform="translate(0.150000, 1.000000)" fill="#ABABAB" fill-rule="nonzero" stroke="#ABABAB" stroke-width="0.9">
                  <path id="Shape" d="M27.85,14.5910417 L27.756852,5.48354167 L27.6363606,5.32375 L14.4300772,0 L14.3089848,0 L14.1878924,0 L0.970491448,5.324375 L0.85,5.47833333 L0.936237021,14.5895833 L1.01496211,14.6964583 L14.2491898,20 L14.4913746,20 L27.7643639,14.70125 L27.85,14.5910417 Z M27.3716399,14.2897917 L23.0805218,12.5685417 L23.2370706,5.7875 L23.1565426,5.68895833 L18.80593,3.94291667 L18.5637452,4.03791667 L18.3510072,10.6947917 L14.433683,9.14708333 L14.433683,0.467291667 L27.2156922,5.581875 L27.3716399,14.2897917 Z M22.7611143,12.4404167 L18.7290078,10.823125 L18.8819508,4.23604167 L22.9131559,5.85875 L22.7611143,12.4404167 Z M14.1332055,0.467291667 L14.1332055,9.18791667 L9.73661985,10.951875 L1.43322668,14.2858333 L1.37553502,5.58125 L14.1332055,0.467291667 Z M14.3705827,19.7070833 L1.65467854,14.59375 L2.79378846,14.1333333 L14.3393331,9.490625 L26.0699717,14.1702083 L27.1225442,14.5925 L14.3705827,19.7070833 Z M5.94669809,9.70854167 L5.71983763,9.61229167 L5.71983763,6.23270833 L5.77933216,6.13625 L10.5935815,4.16666667 L10.8279539,4.26291667 L10.8279539,7.6425 L10.7648536,7.73895833 L5.94669809,9.70854167 Z M6.02031506,6.29666667 L6.02031506,9.41708333 L10.5274764,7.57875 L10.5274764,4.45833333 L6.02031506,6.29666667 Z" />
                </g>
              </g>
            </svg>
          </span>
          <p>{{ flat.rooms }} {{ $tc('flat.rooms', flat.rooms) }}</p>
        </div>
      </div>

      <div class="cell small-6">
        <div class="ad-data">
          <span class="nav-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="20">
              <path
                fill-rule="evenodd"
                d="M26.235807.1250426c.372395 0 .69466.1360676.966795.4082022.272134.2721345.408202.5943994.408202.9667945V18c0 .3723952-.136068.69466-.408202.9667946-.272135.2721345-.5944.4082021-.966795.4082021H1.485866c-.372395 0-.69466-.1360676-.966794-.4082021C.246937 18.69466.11087 18.3723952.11087 18V1.5000393c0-.3723951.136067-.69466.408202-.9667945.272134-.2721346.594399-.4082022.966794-.4082022h24.749941zm0 17.8749574V1.5000393H1.485866V18h24.749941zm-13.406218-5.4999869c-.085937 0-.164713-.035807-.236327-.1074216-.071615-.0716146-.107422-.1503903-.107422-.2363276v-.6874983c0-.0859373.035807-.164713.107422-.2363276.071614-.0716146.15039-.1074216.236327-.1074216h3.437492c.085937 0 .164713.035807.236328.1074216.071614.0716146.107421.1503903.107421.2363276v.6874983c0 .0859373-.035807.164713-.107421.2363276-.071615.0716146-.150391.1074216-.236328.1074216h-3.437492zm10.312476-1.3749967c.085937 0 .164713.035807.236327.1074216.071615.0716146.107422.1503903.107422.2363276v.6874983c0 .0859373-.035807.164713-.107422.2363276-.071614.0716146-.15039.1074216-.236327.1074216h-3.437492c-.085937 0-.164713-.035807-.236328-.1074216-.071614-.0716146-.107421-.1503903-.107421-.2363276v-.6874983c0-.0859373.035807-.164713.107421-.2363276.071615-.0716146.150391-.1074216.236328-.1074216h3.437492zM12.829589 8.3750229c-.085937 0-.164713-.0358069-.236327-.1074216-.071615-.0716146-.107422-.1503902-.107422-.2363275v-.6874984c0-.0859373.035807-.1647129.107422-.2363276.071614-.0716146.15039-.1074216.236327-.1074216h10.312476c.085937 0 .164713.035807.236327.1074216.071615.0716147.107422.1503903.107422.2363276v.6874984c0 .0859373-.035807.1647129-.107422.2363275-.071614.0716147-.15039.1074216-.236327.1074216H12.829589zM5.911637 9.835957c-.401041-.1145833-.723305-.3294266-.966795-.6445297-.243489-.3151032-.365233-.6588524-.365233-1.0312476 0-.4869778.164713-.8951799.494139-1.2246064.329427-.3294266.737629-.5084622 1.224607-.5371081v-.4296865c0-.0859373.035807-.1647129.107421-.2363276.071615-.0716146.150391-.1074216.236328-.1074216h.687498c.085938 0 .164713.035807.236328.1074216.071615.0716147.107422.1503903.107422.2363276v.4296865c.458332.0286459.859372.1718746 1.203122.4296864.085937.0572913.136067.128906.15039.2148433.014323.0859373-.021484.1718746-.107422.2578119l-.515623.5585924c-.085938.1145833-.207682.1289059-.365234.0429686s-.336587-.1289059-.537108-.1289059H6.384292c-.114583 0-.214843.035807-.30078.1074216-.085938.0716146-.128906.1647129-.128906.2792962 0 .1718746.10026.2864579.30078.3437492l1.804683.4726551c.401041.1145833.723306.3294265.966795.6445297.243489.3151032.365233.6588524.365233 1.0312476 0 .4869778-.164713.8951799-.494139 1.2246064-.329427.3294265-.737629.5084621-1.224606.5371081v.4296865c0 .0859373-.035807.1647129-.107422.2363276-.071615.0716146-.15039.1074216-.236328.1074216h-.687498c-.085937 0-.164713-.035807-.236328-.1074216-.071614-.0716147-.107421-.1503903-.107421-.2363276v-.4296865c-.458333-.028646-.859373-.1718746-1.203122-.4296865-.085938-.0572913-.136068-.1289059-.150391-.2148432-.014322-.0859373.021485-.1718746.107422-.2578119l.515624-.5585924c.085937-.1145833.207681-.1289059.365233-.0429686.157552.0859372.336588.1289059.537108.1289059h1.117185c.114584 0 .214843-.035807.300781-.1074216.085937-.0716147.128906-.164713.128906-.2792962 0-.1718746-.10026-.2864579-.300781-.3437492L5.911637 9.835957z" />
            </svg>
          </span>
          <p>{{ flat.rent | currency }} / {{ $t('flat.month') }}</p>
        </div>
      </div>

      <div class="cell small-6">
        <div class="ad-data">
          <span class="nav-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="20">
              <path
                fill-rule="evenodd"
                d="M24.062443 0c.171874 0 .329426.064453.472655.1933589.143228.128906.214843.2936189.214843.4941395v14.867152c0 .2864579-.078776.5442698-.236328.7734357-.157551.2291659-.365233.4010405-.623045.5156237l-6.531234 2.2773384c-.572915.1718746-1.145831.1718746-1.718746 0L8.24998 16.4999607.94531 19.2069855c-.085937.0286459-.171874.0429686-.257812.0429686-.171874 0-.329426-.064453-.472655-.1933589C.071615 18.9276892 0 18.7629763 0 18.5624557V3.6953037c0-.2864579.078776-.5442698.236328-.7734357.157551-.2291659.365233-.4010405.623045-.5156237L7.390607.1289059C7.677065.0429686 7.963522 0 8.24998 0c.286458 0 .572915.0429686.859373.1289059l7.390608 2.6210875 7.30467-2.7070248C23.890568.0143227 23.976505 0 24.062443 0zM1.332028 3.6953037l.042969 13.8788731 6.187485-2.2773383V1.5468713L1.332028 3.6953037zm7.605451 11.6015348l6.874983 2.4062443V3.9531156L8.937479 1.5468713v13.7499672zm8.24998 2.4062443l6.230454-2.1484324-.042969-13.8788731-6.187485 2.2773383v13.7499672z" />
            </svg>
          </span>
          <p>
            {{ flat.size }} m<sup>2</sup>
          </p>
        </div>
      </div>

      <div class="cell small-6">
        <div class="ad-data">
          <span class="nav-icon">
            <!-- <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="20">
              <path
                fill-rule="evenodd"
                d="M24.062443 0c.171874 0 .329426.064453.472655.1933589.143228.128906.214843.2936189.214843.4941395v14.867152c0 .2864579-.078776.5442698-.236328.7734357-.157551.2291659-.365233.4010405-.623045.5156237l-6.531234 2.2773384c-.572915.1718746-1.145831.1718746-1.718746 0L8.24998 16.4999607.94531 19.2069855c-.085937.0286459-.171874.0429686-.257812.0429686-.171874 0-.329426-.064453-.472655-.1933589C.071615 18.9276892 0 18.7629763 0 18.5624557V3.6953037c0-.2864579.078776-.5442698.236328-.7734357.157551-.2291659.365233-.4010405.623045-.5156237L7.390607.1289059C7.677065.0429686 7.963522 0 8.24998 0c.286458 0 .572915.0429686.859373.1289059l7.390608 2.6210875 7.30467-2.7070248C23.890568.0143227 23.976505 0 24.062443 0zM1.332028 3.6953037l.042969 13.8788731 6.187485-2.2773383V1.5468713L1.332028 3.6953037zm7.605451 11.6015348l6.874983 2.4062443V3.9531156L8.937479 1.5468713v13.7499672zm8.24998 2.4062443l6.230454-2.1484324-.042969-13.8788731-6.187485 2.2773383v13.7499672z" />
            </svg> -->
            <svg width="32px" height="21px" viewBox="0 0 32 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="step" transform="translate(1.000000, 0.000000)" fill="#D6D6D6" fill-rule="nonzero" stroke="#D6D6D6" stroke-width="0.3">
                  <path id="Shape" d="M22.4075271,2.15 L22.4075271,10.5 C22.4075271,10.859361 22.1134859,11.15 21.7516742,11.15 L11.2787635,11.15 L11.2787635,19.5 C11.2787635,19.859361 10.9847224,20.15 10.6229107,20.15 L0.505852888,20.15 C0.144041166,20.15 -0.15,19.859361 -0.15,19.5 C-0.15,19.140639 0.144041166,18.85 0.505852888,18.85 C4.61212232,18.85 4.61212232,18.85 8.58482936,18.85 L9.96705776,18.85 L9.96705776,10 L10.1170578,9.85 C10.2376242,9.85 10.2376242,9.85 10.7878664,9.85 C14.198488,9.85 14.198488,9.85 19.9736013,9.85 L21.0958213,9.85 L21.0958213,1.5 C21.0958213,1.14063901 21.3898625,0.85 21.7516742,0.85 C27.2761509,0.85 27.2761509,0.85 29.4432228,0.85 C29.9107449,0.85 30.1465873,1.11108357 30.1499641,1.49869325 C30.1525226,1.79236048 30.0232776,2.15 29.8453204,2.15 L22.4075271,2.15 Z" />
                </g>
              </g>
            </svg>
          </span>
          <p><span v-if="flat.floor == 0">BV eller lägre</span><span v-else>Våning {{ flat.floor }}</span></p>
        </div>
      </div>
    </div>
    <!-- Ad data grid : END -->
    <!-- Tags -->
    <div class="tag-wrap">
      <span v-for="d in flat.details" :key="d" class="card-tag">
        {{ adExtras[d] }}
      </span>
      <div class="clear"></div>
    </div>
    <!-- Tags : END -->
    <!-- </ul></header> -->

    <!-- The API sends no wishes for an archived listing; the check is here as well in case it ever does -->
    <section class="wish-details" v-if="ad && ad.wishes && !ad.archived">
      <h2>Sökes</h2>
      <p>Innehavaren av denna bostad söker minst en {{  ad.wishes.minRooms }}:a 
        <span v-if="ad.wishes.minSize > 0">på minst {{  ad.wishes.minSize }} m<sup>2</sup>.</span>
        <span v-if="ad.wishes.maxRent < 100000">med en maxhyra på {{  ad.wishes.maxRent | currency }} i månaden</span>
        <span> i följande område<span v-if="selectedPaths.length > 1">n</span>:</span>
      
      </p>

       <ul style="padding:0px;list-style:none;font-size:13px;">
      <li v-for="(path, index) in selectedPaths" :key="index">
        {{ path.join(' » ') }}
      </li>
    </ul>

       <!-- <Treeselect
                v-if="locations"
                v-model="ad.wishes.locationIds"
                :multiple="true"
                :searchable="false"
                :options="locations"
                :value-consists-of="'BRANCH_PRIORITY'"
                :flatten-search-results="true"
                placeholder="Var söker du bostad?"
                :loading="true"
                @input="updateFilters" /> -->

      <!-- <pre>{{  JSON.stringify(selectedPaths,null,2) }}</pre> -->
      <!-- <pre>{{  JSON.stringify(ad.wishes,null,2) }}</pre> -->
    </section>
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'

export const adExtras = {
  1: 'Bredband',
  2: 'Kabel - TV',
  3: 'Hiss',
  4: 'Öppen spis',
  5: 'Badkar',
  6: 'Dusch',
  7: 'Förråd',
  8: 'Balkong / Terrass',
  9: 'Balkong',
  10: 'Terrass',
  11: 'Kakelugn'
}

export default {
    components: { Treeselect },

  props: {
    flat: {
      type: Object,
      required: true
    },
    ad: {
      type: Object,
      required: false
    }
  },
  methods: {
getSelectedLocationPaths(locations, selectedIds) {
    const results = [];

    const traverse = (node, path) => {
      if (!node || typeof node !== 'object' || !node.label) return;

      const currentPath = [...path, { id: node.id, label: node.label }];

      if (selectedIds.includes(node.id)) {
        // Clean up path according to hideUnlessLeaf
        const cleanedPath = currentPath.filter((item, idx) => {
          const isLast = idx === currentPath.length - 1;
          return !this.hideUnlessLeaf.includes(item.id) || isLast;
        });

        results.push(cleanedPath.map(p => p.label));
      }

      if (Array.isArray(node.children)) {
        node.children.forEach(child => traverse(child, currentPath));
      }
    };

    locations.forEach(root => traverse(root, []));
    return results;
  }
},
  computed:{
        ...mapState(['filters', 'locations']),
        selectedPaths() {
        return this.getSelectedLocationPaths(this.locations, this.ad.wishes.locationIds || []);
  }
  },
  mounted() {
    if(this.locations.length === 0){

      this.$store.dispatch('getLocations')
    }
  },
  data () {
    return {
    hideUnlessLeaf: [4, 5, 12, 69, 84, 88, 3], // e.g. Stockholms Stad, Göteborgs Stad, Majorna-Linné

      adExtras
    }
  }

}
</script>

<style>

section.wish-details {
  border-top: 1px solid #F6F7F9;
  padding: 25px 30px;
  /* margin-top: 1rem; */
  /* padding: 0.5rem; */
  /* background-color: #f9f9f9; */
  /* border-radius: 0.5rem; */
}

section.wish-details h2{
  font-size: 19px;
}
</style>
